import createIsPristine from '../selectors/isPristine';
import immutable from '../structure/immutable';

export default createIsPristine(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/isPristine.js
// module id = 1207
// module chunks = 0